module.exports = __webpack_public_path__ + "static/media/Promotion_Card.b943df15.png";